import React, { useCallback, useState } from 'react';

import PopperCard from '../../../design_system/popper_card/popper_card';
import List from '../../../design_system/list/list';
import ListItem from '../../../design_system/list_item/list_item';

import classes from './sort_dropdown.module.css';

const filtersToDisplay = ['desc', 'asc'];

const getLabelFromValue = (value) => {
	if (value === 'asc') {
		return 'Du - récent au + récent'
	}
	return 'Du + récent au - récent'
}

const DateDropdown = ({ ...other }) => {
	const [activeFilters, setActiveFilters] = useState([]);
	const [, setUpdateState] = useState();
	const handleSelection = useCallback((label) => {
		const newFilters = activeFilters;
		if (activeFilters.includes(label)) {
			newFilters.splice(activeFilters.indexOf(label), 1);
		} else {
			newFilters.push(label);
		}
		setActiveFilters(newFilters);
		setUpdateState({});
	}, [activeFilters]);
	return (
		<PopperCard
			className={classes.container}
			{...other}
		>
			<List>
				{filtersToDisplay.map((value) => {
					return (
						<ListItem
							className={classes.listItem}
							button
							onClick={() => handleSelection(value)}
						>
							<span>
								{getLabelFromValue(value)}
							</span>
						</ListItem>
					);
				})}
			</List>
		</PopperCard>
	);
}

export default DateDropdown;
